import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { EncryptionUrlService } from 'app/services/common/encryption-url.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeliveryService } from 'app/services/models/delivery.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-delivery-list',
  templateUrl: './delivery-list.component.html',
  styleUrls: ['./delivery-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  companies: any[] = [];
  selectedCompanyId = null;

  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;
  constructor(
    private deliveryService: DeliveryService,
    private router: Router,
    private encryptionService: EncryptionUrlService,
    private companyService: CompanyService,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private datePipe: DatePipe,
  ) { }

  async ngOnInit() {
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
    await this.getAllCompanies();
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async onCompanySelect(event) {
    console.log(event);
    this.selectedCompanyId = event.id;
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  async getAllDeliveries(page, size, search, startDate, endDate, companyId) {
    const data = await this.deliveryService.getAllDeliveries(page, size, search, startDate, endDate, companyId);
    console.log(data);
    this.rows = data.deliveries;
    this.totalCount = data.totalCount;
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  async onPageChange() {
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {
      console.log(event.row.id);
      this.router.navigate([`/admin/delivery-update/${event.row.id}`]);
    }
  }

  async resetFilter() {
    this.startFilterDate = null;
    this.endFilterDate = null;
    this.selectedCompanyId = null;
    this.fromDate = null;
    this.toDate = null
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  async onOptionDateChange() {
    // Tarih değiştiğinde yapılacak işlemler buraya
    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;

  /**
 * Range selection Date Picker
 *
 * @param date
 */
  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    console.log('Start Date:', startDateFormatted ? startDateFormatted : 'Not selected');
    console.log('End Date:', endDateFormatted ? endDateFormatted : 'Not selected');

    this.startFilterDate = (startDateFormatted).toString();
    this.endFilterDate = (endDateFormatted).toString();

    await this.getAllDeliveries(this.pageBasic - 1, this.selectedSize, this.searchValue, this.startFilterDate, this.endFilterDate, this.selectedCompanyId);
  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;
    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);
    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate));
  }

  /**
   * Is Inside
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }
}